import { useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore from '../../redux';
import {
  API_DELETE_RULE_CONFIGURATION,
  API_DELETE_SOLUTION_ALERT_RULES,
  API_WORKLOAD_CONFIG_DELETE,
} from '../../constants';
import { SolutionAlertRuleItem, SolutionEdgeWorkloadItem } from '../../types';
import { SolutionRuleConfigurationItem } from '../../types/solutionRulesConfiguration';

type Props = {
  item: SolutionRuleConfigurationItem;
  open: boolean;
  onClose: ModalCloseHandler;
  itemIds: string[];
};

function SolutionRuleConfigurationDeleteModal({
  item,
  open,
  onClose,
  itemIds,
}: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);
  const [handleDelete, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generateApiPath(API_DELETE_RULE_CONFIGURATION, { solutionId }),
        params: { ids: itemIds && itemIds.length > 0 ? itemIds : [item.id] },
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: `Rule is deleted`,
        text: `${item.name} Rule has been deleted successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.ruleConfiguration(solutionId);
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Delete Rule Configuration"
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelBtnText="No"
      confirmBtnText="Yes"
      maxWidth="sm"
      fullWidth
    >
      Are you sure you want to delete the Rule?<br></br>
      <b>{item?.name}</b>
    </ModalDialog>
  );
}

export default SolutionRuleConfigurationDeleteModal;
